module.exports = __webpack_public_path__ + "static/media/property-details.67e027a9.png";